export const EMPTY_LOGIN_PASSWORD = 'You need both username and password to login';
export const BAD_CREDENTIALS = 'Bad credentials';
export const EMPTY_NEW_PASSWORD = 'All fields need to be filled to change password';
export const NEW_PASSWORDS_NO_MATCH = 'New password and Confirm new password fields must match';
export const UNKNOWN_ERROR = 'Unknown error. Please contact Saagie support';
